import { render } from "./IconSearch.vue?vue&type=template&id=0579e3d1&scoped=true"
import script from "./IconSearch.vue?vue&type=script&lang=js"
export * from "./IconSearch.vue?vue&type=script&lang=js"

import "./IconSearch.vue?vue&type=style&index=0&id=0579e3d1&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\ms\\ms-by-bimms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0579e3d1"]])

export default __exports__